module.exports = __webpack_public_path__ + "static/img/case_detail_14_2.37cd7c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_14_2.png
// module id = HVuu
// module chunks = 34